import { render } from "./BlogsPage.vue?vue&type=template&id=6e7bf0fa&scoped=true"
import script from "./BlogsPage.vue?vue&type=script&lang=js"
export * from "./BlogsPage.vue?vue&type=script&lang=js"

import "./BlogsPage.vue?vue&type=style&index=0&id=6e7bf0fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7bf0fa"]])

export default __exports__